import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { getSettingTopicInfos } from '../utils/crosstabDataUtils'
import { CrosstabWidgetsType } from '../../types'

const CrosstabTopicInaccessibleGuard: WidgetGuard = ({ widgetId, children }) => {
  const { t } = useTranslation()
  const widgetSetting = useDashboardWidgetSetting<CrosstabWidgetsType>(widgetId)
  const topicInfos = getSettingTopicInfos(widgetSetting)

  if (!topicInfos || topicInfos.length === 0) {
    return <ErrorMessage>{t('topicInaccessible')}</ErrorMessage>
  }

  return children
}

export default CrosstabTopicInaccessibleGuard
